import { OpcaoMenu } from '../../../shared/menus/opcao-menu.interface';

const tituloMenuLateralCondicaoQualidade = '4. Condições de qualidade';
const caminhoImagemLateralCondicaoQualidade =
  '../../../assets/quality_conditions_icon.svg';
const corFundoLateralCondicaoQualidade = '#c42d27';

const opcoesMenuLateralAtivas: OpcaoMenu[] = [
  {
    rotulo: 'Número de dias letivos',
    caminho: '/condicao-qualidade/numero-de-dias-letivos',
    selecionado: false,
  },
  {
    rotulo: 'Carga horária de ensino',
    caminho: '/condicao-qualidade/carga-horaria-de-ensino',
    selecionado: false,
  },
  {
    rotulo: 'Tamanho das turmas',
    caminho: '/condicao-qualidade/tamanho-das-turmas',
    selecionado: false,
  },
  {
    rotulo: 'Docentes: formação e remuneração',
    caminho: '/condicao-qualidade/docente-formacao-remuneracao',
    selecionado: false,
  },
  {
    rotulo: 'Docentes: quantidade por etapa/modalidade',
    caminho: '/condicao-qualidade/numero-professores',
    selecionado: false,
  },
  {
    rotulo: 'Funcionários: quadro e remuneração',
    caminho: '/condicao-qualidade/quadro-funcionarios-remuneracao',
    selecionado: false,
  },
  {
    rotulo: 'Funcionários: quantidade por função',
    caminho: '/condicao-qualidade/numero-funcionarios-funcao',
    selecionado: false,
  },
  {
    rotulo: 'Serviços, infraestrutura e recursos',
    caminho: '/condicao-qualidade/manutencao-das-escolas',
    selecionado: false,
  },
  {
    rotulo: 'Alimentação escolar',
    caminho: '/condicao-qualidade/alimentacao-escolar',
    selecionado: false,
  },
  {
    rotulo: 'Adicional para modalidades e contextos',
    caminho: '/condicao-qualidade/fator-ponderacao',
    selecionado: false,
  },
];

const opcoesMenuLateralInativas: OpcaoMenu[] = [
  { rotulo: 'Salas de aula: diagnóstico e projeção', caminho: '#' },
  { rotulo: 'Espaços escolares: reforma e adequação', caminho: '#' },
  { rotulo: 'Tempo integral', caminho: '#' },
  { rotulo: 'Jornada de trabalho docente', caminho: '#' },
  { rotulo: 'Formação continuada', caminho: '#' },
  { rotulo: 'Funcionamento e manutenção das escolas', caminho: '#' },
  { rotulo: 'Transporte escolar', caminho: '#' },
  { rotulo: 'Equipamentos e mobiliário', caminho: '#' },
];

export {
  opcoesMenuLateralAtivas,
  opcoesMenuLateralInativas,
  tituloMenuLateralCondicaoQualidade,
  caminhoImagemLateralCondicaoQualidade,
  corFundoLateralCondicaoQualidade,
};
